import type { ItemType } from 'antd/es/breadcrumb/Breadcrumb';

import ConfigurationIcon from '@asset/configuration.icon.svg?react';
import ConsumerIcon from '@asset/consumer.icon.svg?react';
import CredentialIcon from '@asset/credential.icon.svg?react';
import DashboardIcon from '@asset/dashboard.icon.svg?react';
import LogsIcon from '@asset/logs.icon.svg?react';
import OverviewIcon from '@asset/overview.icon.svg?react';
import SequencesIcon from '@asset/sequences.icon.svg?react';
import SettingsIcon from '@asset/settings.icon.svg?react';
import UserIcon from '@asset/user.icon.svg?react';
import WebhooksIcon from '@asset/webhooks.icon.svg?react';
import { IntegrationName } from '@component/header/integration-name/integration-name';
import { RouteEnum } from '@enum/route.enum';
import { ColorEnum } from '@enum/style/color.enum';
import type { RouteInterface } from '@interface/route/route.interface';

import { ConsumerName } from './consumer-name/consumer-name';
import { PageLabel, PageLabelWrapper } from './header.style';

interface BreadcrumbOptionListInterface {
  [key: string]: Array<ItemType & { link?: RouteInterface }>;
}

export const BreadcrumbOptionList: BreadcrumbOptionListInterface = {
  [RouteEnum.Overview.name]: [
    {
      title: (
        <PageLabelWrapper>
          <OverviewIcon fill={ColorEnum.Black100} width={14} />
          <PageLabel>Overview</PageLabel>
        </PageLabelWrapper>
      ),
    },
  ],
  [RouteEnum.Settings.name]: [
    {
      title: (
        <PageLabelWrapper>
          <UserIcon fill={ColorEnum.Black100} width={14} />
          <PageLabel>User settings</PageLabel>
        </PageLabelWrapper>
      ),
    },
  ],
  [RouteEnum.Dashboard.name]: [
    {
      title: (
        <PageLabelWrapper>
          <DashboardIcon fill={ColorEnum.Black100} width={14} />
          <PageLabel>Dashboard</PageLabel>
        </PageLabelWrapper>
      ),
    },
  ],
  [RouteEnum.Credentials.name]: [
    {
      title: (
        <PageLabelWrapper>
          <CredentialIcon fill={ColorEnum.Black100} width={14} />
          <PageLabel>Credentials</PageLabel>
        </PageLabelWrapper>
      ),
    },
  ],
  [RouteEnum.Consumers.name]: [
    {
      title: (
        <PageLabelWrapper>
          <ConsumerIcon fill={ColorEnum.Black100} width={14} />
          <PageLabel>Consumers</PageLabel>
        </PageLabelWrapper>
      ),
      link: RouteEnum.Consumers,
    },
  ],
  [RouteEnum.Integrations.name]: [
    {
      title: (
        <PageLabelWrapper>
          <ConfigurationIcon fill={ColorEnum.Black100} width={14} />
          <PageLabel>Integrations</PageLabel>
        </PageLabelWrapper>
      ),
      link: RouteEnum.Integrations,
    },
  ],
  [RouteEnum.AccountSettings.name]: [
    {
      title: (
        <PageLabelWrapper>
          <SettingsIcon fill={ColorEnum.Black100} width={14} />
          <PageLabel>Account settings</PageLabel>
        </PageLabelWrapper>
      ),
      link: RouteEnum.AccountSettings,
    },
  ],
  [RouteEnum.Webhooks.name]: [
    {
      title: (
        <PageLabelWrapper>
          <WebhooksIcon fill={ColorEnum.Black100} width={14} />
          <PageLabel>Webhooks</PageLabel>
        </PageLabelWrapper>
      ),
      link: RouteEnum.Webhooks,
    },
  ],
  [RouteEnum.Sequences.name]: [
    {
      title: (
        <PageLabelWrapper>
          <SequencesIcon fill={ColorEnum.Black100} width={14} />
          <PageLabel>Sequences</PageLabel>
        </PageLabelWrapper>
      ),
      link: RouteEnum.Sequences,
    },
  ],
  [RouteEnum.Logs.name]: [
    {
      title: (
        <PageLabelWrapper>
          <LogsIcon fill={ColorEnum.Black100} width={14} />
          <PageLabel>Logs</PageLabel>
        </PageLabelWrapper>
      ),
      link: RouteEnum.Logs,
    },
  ],
};

BreadcrumbOptionList[RouteEnum.ConsumerView.name] = [
  ...BreadcrumbOptionList[RouteEnum.Consumers.name],
  { title: <ConsumerName /> },
];

BreadcrumbOptionList[RouteEnum.IntegrationView.name] = [
  ...BreadcrumbOptionList[RouteEnum.Integrations.name],
  { title: <IntegrationName /> },
];

BreadcrumbOptionList[RouteEnum.PaymentHistory.name] = [
  ...BreadcrumbOptionList[RouteEnum.AccountSettings.name],
  {
    title: (
      <PageLabelWrapper>
        <PageLabel ml={0}>Payment history</PageLabel>
      </PageLabelWrapper>
    ),
  },
];

BreadcrumbOptionList[RouteEnum.WorkspacePlan.name] = [
  ...BreadcrumbOptionList[RouteEnum.AccountSettings.name],
  {
    title: (
      <PageLabelWrapper>
        <PageLabel ml={0}>Upgrade workspace plan</PageLabel>
      </PageLabelWrapper>
    ),
  },
];

BreadcrumbOptionList[RouteEnum.NewSequences.name] = [
  ...BreadcrumbOptionList[RouteEnum.Sequences.name],
  {
    title: (
      <PageLabelWrapper>
        <PageLabel ml={0}>New Sequences</PageLabel>
      </PageLabelWrapper>
    ),
  },
];
